<template>
  <div class="mb-4 reason-option-container">
    <vs-row class="align-middle">
      <div class="reason-option-description">
        <vs-input 
          v-validate="'required'" 
          class="mb-4 w-full p-" 
          v-model="list.description"
          label-placeholder="Descrição" 
          :name="'description' + index" 
        />

        <span
          class="text-danger text-sm"
          v-show="errors.has('description'+index)"
        >
          Campo de preenchimento obrigatório
        </span>
      </div>

      <div class="reason-option-kind mb-4" style="min-width: 30%">
          <div class="mt-5">
            <span>Tipo:</span>
          </div>

          <v-select
            class="w-full col" :value="list.reason_option_kind_id" v-model="kindSelected"
            :options="kinds" id="id" label="description" @input="resetItems"
          >
            <template #option="{ tag, description }">
                <div class="icon-i" v-if="tag === 'select'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 18 18" width="18px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M3,5v14h18V5H3z M7,7v2H5V7H7z M5,13v-2h2v2H5z M5,15h2v2H5V15z M19,17H9v-2h10V17z M19,13H9v-2h10V13z M19,9H9V7h10V9z"/></svg>
                </div>
                <div class="icon-i" v-if="tag === 'boolean'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
                </div>
                <div class="icon-i" v-if="tag === 'radio'">
                    <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/><circle cx="12" cy="12" r="5"/></svg>
                </div>
                <div class="icon-i" v-if="tag === 'checkbox'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M22,7h-9v2h9V7z M22,15h-9v2h9V15z M5.54,11L2,7.46l1.41-1.41l2.12,2.12l4.24-4.24l1.41,1.41L5.54,11z M5.54,19L2,15.46 l1.41-1.41l2.12,2.12l4.24-4.24l1.41,1.41L5.54,19z"/></svg>
                </div>
                <div class="icon-i" v-if="tag === 'decimal'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15 16h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zm-7 6h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zM5 8h2v8H5zM2 4v16h20V4H2zm18 14H4V6h16v12z"/></svg>
                </div>
                
                <div class="icon-i" v-if="tag === 'currency'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>
                </div>

                <div class="icon-i" v-if="tag === 'int'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><g><path d="M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,18H4V6h16V18z"/><polygon points="6.49,10.5 6.49,15 7.64,15 7.64,9 6.77,9 5.01,10.27 5.59,11.16"/><path d="M11.47,10.05c0.5,0,0.81,0.32,0.81,0.72c0,0.37-0.14,0.64-0.54,1.06c-0.36,0.38-1.06,1.08-2.13,2.15V15h3.89v-0.99h-2.37 l-0.03-0.05c0.68-0.68,1.15-1.14,1.4-1.39c0.61-0.6,0.92-1.22,0.92-1.86c0-0.24-0.05-1.04-0.91-1.48C12.04,9,11.25,8.87,10.56,9.2 c-0.82,0.39-0.99,1.13-1,1.15l1.01,0.42C10.67,10.44,10.95,10.05,11.47,10.05z"/><path d="M16.99,13.94c-0.83,0-0.99-0.76-1.02-0.86l-1.03,0.41c0.45,1.59,2.01,1.51,2.05,1.51c1.2,0,1.68-0.72,1.76-0.85 c0.32-0.49,0.36-1.24-0.01-1.76c-0.17-0.24-0.4-0.41-0.68-0.52V11.8c0.2-0.1,0.37-0.26,0.52-0.48c0.26-0.41,0.31-1.07-0.02-1.57 C18.48,9.64,18.03,9,16.94,9c-1.26,0-1.74,0.9-1.85,1.24l0.99,0.41c0.11-0.32,0.35-0.64,0.85-0.64c0.44,0,0.75,0.26,0.75,0.65 c0,0.58-0.55,0.72-0.88,0.72h-0.46v1h0.5c0.56,0,1.04,0.24,1.04,0.79C17.88,13.66,17.4,13.94,16.99,13.94z"/></g></g></svg>
                </div>

                <div class="icon-i" v-if="tag === 'text'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M4 9h16v2H4V9zm0 4h10v2H4v-2z"/></svg>
                </div>

                <div class="description">
                  {{description}}
                </div>
            </template>
          </v-select>
      </div>
      <div class="reason-option-button">
        <div>
          <vs-dropdown vs-custom-content>
            <vs-button class="btn-drop mr-2" type="filled" icon="more_vert"></vs-button>

            <vs-dropdown-menu>
              <vs-dropdown-item>
                <div class="flex" @click.prevent="updateIsRequired">
                  <vs-switch class="mr-3" v-model="list.is_required"/>
                  <p class="">Obrigatório</p>
                </div>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <div class="flex" @click.prevent="remove">
                  <feather-icon
                    class="ml-3 mr-2"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5  stroke-current"
                  /> 
                  <p class="ml-5">Remover</p>
                </div>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
    </vs-row>

    <div v-if="kindSelected && kindSelected.min_items > 0" class="reason-option-items">
      <div>
        <component
          :index="index"
          :identifier="null"
          :ableToRemove="ableToRemoveItem"
          @onRemoveReasonOptionItem="removeReasonOptionItem"
          v-for="(item, index) in items"
          :item="list['reason_option_items_attributes'][index]"
          :key="index"
          :is="item"
        />
      </div>
      <vs-button v-if="ableToAdd" type="flat" @click.prevent="addItem">Adicionar Item</vs-button>
    </div>
  </div>
</template>
<script>
  import requests from '@/http/requests/reasonOptionKind'
  import ReasonOptionItem from '@/views/reason-options/Item'

  import vSelect from 'vue-select'
  import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
  import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
  import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";

  export default {
    name: 'reason-options-form',
    components: {VsDropdownMenu, VsDropdown, VsDropdownItem, 'v-select': vSelect, },
    inject: ['$validator'],
    props: {
      index: {
        type: Number,
        required: true
      },
      list: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        items: [],
        kinds: [],
        kind: null,
        kindSelected: null,
        showObservation: false,
        ableToRemoveItem: false,
        kindWatcherEnabled: false,
        requireObservation: false,
      }
    },
    mounted () {
      this.$store.dispatch('setShowLoadingOverlay', true)

      requests.fetch().then((response) => {
        this.kinds = response.data.data.reasonOptionKinds
        this.$store.dispatch('setShowLoadingOverlay', false)
        this.filterkindSelected()
      }).catch((error) => {
        this.$store.dispatch('setShowLoadingOverlay', false)
        console.error(error)
      })
    },
    computed: {
      currentItems () {
        return this.items.filter((item) => {
          return item !== null
        })
      },
      ableToAdd () {
        return this.kindSelected && this.currentItems.length < this.kindSelected.max_items
      }
    },
    watch: {
      items() {
        if (this.kindSelected === null ) { return }
        this.ableToRemoveItem = !(this.kindSelected && this.currentItems.length <= this.kindSelected.min_items);
      },
      description(value) {
        this.list['description'] = value
      },
      list(){
        this.filterkindSelected()
      },
      kindSelected(item) {
        this.list.reason_option_kind = item
        this.list.reason_option_kind_id = item.id
      }
    },
    methods: {
      filterkindSelected(){
        this.kinds.filter((i) => {
          if(i.id === this.list.reason_option_kind_id) {
            this.kindSelected = i
          }
        }) 

        this.list['reason_option_items_attributes'].forEach(() => {
          this.items.push(ReasonOptionItem)
        })

        if (this.list.reason_option_kind_id === null) {
          this.list.reason_option_kind_id = this.kinds[0].id
          this.list.reason_option_kind = this.kinds[0]
        }
      },
      resetItems () {
        this.items.forEach((item, index) => {
          this.removeReasonOptionItem(index)
        })

        while (this.items.length < this.kindSelected.min_items) {
          this.addItem()
        }
      },
      addItem () {
        this.list['reason_option_items_attributes'].push({
          description: ''
        })

        this.items.push(ReasonOptionItem)
      },
      removeReasonOptionItem (idx) {
        this.$store.dispatch('setShowLoadingOverlay', true)
  
        let removed = this.list['reason_option_items_attributes'][idx];
        if ( removed && removed.id ) { this.remove({
            id: parseInt(removed.id), 
            reasonOptionId: parseInt(this.list.id)
          }) 
        }

        this.list['reason_option_items_attributes'].splice(idx, 1)
        this.items.splice(idx, 1)

        this.$store.dispatch('setShowLoadingOverlay', false)
      },
      remove ({id = null, reasonOptionId = null}) {
        this.$emit('onRemoveReasonOption', this.index, {
          id: id, 
          reasonOptionId: reasonOptionId
        })
      },
      updateIsRequired () {
        this.list.is_required = !this.list.is_required
      }
    }
  }
</script>
<style lang="scss" scoped>
  .align-middle {
    align-items: center;
    justify-content: space-between;
  }

  .reason-option-container {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding-bottom: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .reason-option-header {
    display: flex;
    align-items: center;
  }

  .reason-option-description {
    width: 60%;
    margin-top: 25px;

    @media(max-width: 899px) {
      width: 100%;
    }
  }

  .reason-option-button {
    margin-top: 27px;
  }

  .reason-option-items {
    margin-left: 20px;
  }
</style>



<style scoped>
  .icon-i {
    float: left;
    margin-right: 15px;
  }
</style>